import { render } from "./ProcedureAccessDlg.vue?vue&type=template&id=0532fab0&scoped=true"
import script from "./ProcedureAccessDlg.vue?vue&type=script&lang=js"
export * from "./ProcedureAccessDlg.vue?vue&type=script&lang=js"

import "./ProcedureAccessDlg.vue?vue&type=style&index=0&id=0532fab0&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0532fab0"]])

export default __exports__